import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mt-4 mb-6 mx-2" }
const _hoisted_2 = { class: "ats-body flex gap-4 pt-4 overflow-y-scroll flex-grow" }
const _hoisted_3 = { class: "flex-1 treatment-options-wrapper p-1 flex flex-col items-center justify-start" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = {
  key: 0,
  class: "fixedScrollable fullSize"
}
const _hoisted_6 = {
  key: 1,
  class: "fixedScrollable fullSize"
}
const _hoisted_7 = { class: "appointment-wrapper flex-1 flex flex-col items-center p-1" }
const _hoisted_8 = { class: "text-button mb-4 pt-2 flex items-center gap-2" }
const _hoisted_9 = { class: "w-full bg-[#e6e5e5] rounded mb-2 overflow-y-scroll py-2 px-4 fixedScrollable" }
const _hoisted_10 = {
  key: 0,
  class: "w-full h-full"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "telehealth-actions w-full my-2"
}
const _hoisted_13 = { class: "mt-6 mb-3 px-2 w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextCard = _resolveComponent("TextCard")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-button mb-4 pt-2" }, " TREATMENTS ", -1)),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.interactWithBoard)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.treatments, (treatment, i) => {
                  return (_openBlock(), _createBlock(_component_TextCard, {
                    key: treatment.id,
                    class: _normalizeClass(["mb-2 cursor-pointer mx-1 w-full", [{ 'disabledTreatment': !_ctx.todayAndNotCompleted }]]),
                    unripple: !_ctx.todayAndNotCompleted,
                    context: _ctx.todayAndNotCompleted,
                    error: _ctx.getTreatmentError(i),
                    text: treatment.name,
                    "onClick:cardDefault": ($event: any) => (_ctx.todayAndNotCompleted ? _ctx.$emit('card-default-click', treatment) : null),
                    "onClick:cardError": ($event: any) => (_ctx.todayAndNotCompleted ? _ctx.$emit('select-treatment', treatment) : null),
                    "onClick:context": ($event: any) => (_ctx.todayAndNotCompleted ? _ctx.$emit('select-treatment', treatment) : null)
                  }, null, 8, ["class", "unripple", "context", "error", "text", "onClick:cardDefault", "onClick:cardError", "onClick:context"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.interactWithBoard)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.treatments, (treatment, i) => {
                  return (_openBlock(), _createBlock(_component_TextCard, {
                    key: treatment.id,
                    class: "mb-2 cursor-pointer mx-1 w-full",
                    unripple: "",
                    context: "",
                    error: _ctx.getTreatmentError(i),
                    text: treatment.name
                  }, null, 8, ["error", "text"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[7] || (_cache[7] = _createTextVNode(" APPOINTMENT ", -1)),
          (_ctx.telehealthRoom)
            ? (_openBlock(), _createBlock(_component_v_icon, {
                key: 0,
                color: "red-darken-2",
                size: 18,
                title: "Online video visit"
              }, {
                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                  _createTextVNode("mdi-video", -1)
                ]))]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.apptTreatmentList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_ctx.interactWithBoard && _ctx.showDraggable && _ctx.apptTreatmentList.length)
                  ? (_openBlock(), _createBlock(_component_draggable, {
                      key: 0,
                      list: _ctx.apptTreatmentList,
                      class: "list-group",
                      "ghost-class": "ghost",
                      move: _ctx.checkMove,
                      onStart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('drag-start'))),
                      onEnd: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('drag-end')))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apptTreatmentList, (treatment, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: `appointment-${i}-${treatment.treatment ? treatment.treatment.uuid : treatment.uuid}`
                          }, [
                            (treatment.treatment && treatment.treatment.uuid && !treatment.ended_at)
                              ? (_openBlock(), _createBlock(_component_TextCard, {
                                  key: 0,
                                  class: "list-group-item mb-2 cursor-pointer",
                                  remove: "",
                                  unripple: "",
                                  selected: !!treatment.ended_at,
                                  text: _ctx.treatmentName(treatment),
                                  initials: _ctx.$filters.initials(treatment.doctor.name),
                                  initialsColor: treatment.doctor.color,
                                  duration: treatment.duration,
                                  "onClick:remove": ($event: any) => (_ctx.$emit('remove-treatment', treatment.uuid))
                                }, null, 8, ["selected", "text", "initials", "initialsColor", "duration", "onClick:remove"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["list", "move"]))
                  : _createCommentVNode("", true),
                (!_ctx.interactWithBoard)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apptTreatmentList, (treatment, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: `appointment-${i}-${treatment.treatment ? treatment.treatment.uuid : treatment.uuid}`
                        }, [
                          (treatment.treatment && treatment.treatment.uuid && !treatment.ended_at)
                            ? (_openBlock(), _createBlock(_component_TextCard, {
                                key: 0,
                                class: "list-group-item mb-2 cursor-pointer",
                                unripple: "",
                                selected: !!treatment.ended_at,
                                text: _ctx.treatmentName(treatment),
                                initials: _ctx.$filters.initials(treatment.doctor.name),
                                initialsColor: treatment.doctor.color,
                                duration: treatment.duration
                              }, null, 8, ["selected", "text", "initials", "initialsColor", "duration"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.completedTreatments, (treatment, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `appointment-complete-${i}-${treatment.treatment ? treatment.treatment.uuid : treatment.uuid}`,
                    class: "completed-treatment"
                  }, [
                    (treatment.treatment && treatment.treatment.uuid)
                      ? (_openBlock(), _createBlock(_component_TextCard, {
                          key: 0,
                          class: "list-group-item mb-2",
                          disabled: "",
                          selected: !!treatment.ended_at,
                          text: _ctx.treatmentName(treatment),
                          initials: _ctx.$filters.initials(treatment.doctor.name),
                          initialsColor: treatment.doctor.color,
                          duration: treatment.duration
                        }, null, 8, ["selected", "text", "initials", "initialsColor", "duration"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_v_btn, {
          class: "w-full",
          color: "primary",
          disabled: !_ctx.canApplyLastAppointment || _ctx.isProcessing,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('apply-last-appointment')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.isProcessing ? 'Processing...' : 'LOAD LAST APPOINTMENT'), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        (_ctx.telehealthRoom)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_v_btn, {
                class: "flex-1",
                color: "bg-gray-50",
                href: _ctx.telehealthRoom.url,
                target: "_blank",
                rel: "noopener"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    color: "red-darken-2",
                    size: 18,
                    title: "Online video visit"
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("mdi-video", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[9] || (_cache[9] = _createTextVNode("  START VIDEO CALL ", -1))
                ]),
                _: 1
              }, 8, ["href"]),
              _createVNode(_component_v_btn, {
                icon: "",
                density: "comfortable",
                title: _ctx.copyLabel,
                "aria-label": _ctx.copyLabel,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('copy-link')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    color: _ctx.linkCopied ? 'green-darken-2' : undefined,
                    size: 20
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.linkCopied ? 'mdi-check' : 'mdi-content-copy'), 1)
                    ]),
                    _: 1
                  }, 8, ["color"])
                ]),
                _: 1
              }, 8, ["title", "aria-label"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_v_btn, {
          class: "w-full",
          color: "bg-gray-50",
          disabled: !_ctx.canClearAppointment,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('clear-appointment')))
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode(" CLEAR ", -1)
          ]))]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _cache[13] || (_cache[13] = _createElementVNode("div", null, [
        _createElementVNode("p", { class: "flag-title mb-3" }, "TYPES AND FLAGS")
      ], -1)),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentOpenFlags, (flag, index) => {
          return (_openBlock(), _createBlock(_component_v_chip, {
            key: `treatment-flags-${index}`,
            class: "mr-2 mb-2 flags"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "red-darken-2",
                size: 18
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("mdi-flag", -1)
                ]))]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(`${flag.message}${flag.description ? `: ${flag.description}` : ''}`), 1)
            ]),
            _: 2
          }, 1024))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentOpenTractionFlags, (tFlag, index) => {
          return (_openBlock(), _createBlock(_component_v_chip, {
            key: `treatment-t-flags-${index}`,
            class: "mr-2 mb-2 tFlags"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                color: "green-darken-2",
                size: 18
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode("mdi-flag", -1)
                ]))]),
                _: 1
              }),
              _createTextVNode(" " + _toDisplayString(`${tFlag.message}${tFlag.description ? `: ${tFlag.description}` : ''}`), 1)
            ]),
            _: 2
          }, 1024))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentOpenProfiles, (profile, index) => {
          return (_openBlock(), _createBlock(_component_v_chip, {
            key: `treatment-profiles-${index}`,
            class: "mr-2 mb-2 types"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(profile.name), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ])
  ]))
}